import { render } from "./parameterList.component.vue?vue&type=template&id=52e905fa&scoped=true&ts=true"
import script from "./parameterList.component.vue?vue&type=script&lang=ts"
export * from "./parameterList.component.vue?vue&type=script&lang=ts"

import "./parameterList.component.vue?vue&type=style&index=0&id=52e905fa&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e905fa"]])

export default __exports__